import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";
import Swal from "sweetalert2";

export const goldAndSliverBuyApi = createAsyncThunk(
  "goldAndSilverBuy",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `/augmont/buyinfo/${payload.merchantTransactionId}`
      );
      const { data, error, message } = response.data;

      if (!error) {
        return response.data;
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: message || "An unexpected error occurred.",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  data: [],
  errors: false,
  status: false,
};

const goldAndSilverBuySlice = createSlice({
  name: "goldAndSilverBuy",
  initialState,
  reducers: {
    resetState: (state) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(goldAndSliverBuyApi.pending, (state) => {
        state.status = true;
        state.errors = false;
      })
      .addCase(goldAndSliverBuyApi.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = false;
      })
      .addCase(goldAndSliverBuyApi.rejected, (state, action) => {
        // state.data.push(action.payload);
        state.errors = true;
        state.status = false;
      });
  },
});

export const { resetState } = goldAndSilverBuySlice.actions;

export default goldAndSilverBuySlice.reducer;
